(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gingerkite-sticky-buy')) {
    customElements.define('gingerkite-sticky-buy', class extends HTMLElement {
      connectedCallback() {
        this.buttonContainer = this.querySelector('.accelerated-checkout-block');
        if (!this.buttonContainer) return;

        this.resizeObserver = new ResizeObserver(() => {
          if (!this.hasAttribute('data-sticky')) {
            this.style.setProperty('--gingerkite-buy-height', this.buttonContainer.offsetHeight + 'px');
          }
          document.body.style.setProperty('--gingerkite-sticky-space', this.buttonContainer.offsetHeight + 'px');
        });
        this.resizeObserver.observe(this.buttonContainer);

        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          this.toggleAttribute('data-sticky', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
        }, { threshold: 0 });
        this.visibilityObserver.observe(this);
        this.startMeasurement();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.measurementController?.abort();
        this.measurementObserver?.disconnect();
        this.buttonObserver?.disconnect();
        clearTimeout(this.viewTimer);
        cancelAnimationFrame(this.measurementFrame);
      }

      startMeasurement() {
        this.measurementController?.abort();
        this.measurementController = new AbortController();
        this.viewedPlacements ??= new Set();
        this.buttonSelector = 'shopify-buy-it-now-button, shop-pay-wallet-button, shopify-amazon-pay-button, shopify-apple-pay-button, shopify-google-pay-button, shopify-paypal-button, .shopify-payment-button__button--unbranded';
        this.internalTest = new URLSearchParams(location.search).get('utm_source') === 'internal' || new URLSearchParams(location.search).has('preview_theme_id');
        const options = { signal: this.measurementController.signal };
        this.addEventListener('click', event => {
          const button = event.composedPath().find(node => node instanceof Element && node.matches(this.buttonSelector));
          if (!event.isTrusted || !button || !this.contains(button) || button.matches(':disabled, [disabled], [aria-disabled="true"]') || this.buttonContainer.hidden) return;
          this.sendMeasurement('buy_now_clicked', this.measurementPlacement());
        }, { ...options, capture: true, passive: true });
        const refresh = () => {
          cancelAnimationFrame(this.measurementFrame);
          this.measurementFrame = requestAnimationFrame(() => this.refreshMeasurement());
        };
        document.addEventListener('visitorConsentCollected', refresh, options);
        document.addEventListener('visibilitychange', refresh, options);
        document.addEventListener('toggle', refresh, { ...options, capture: true });
        window.addEventListener('scroll', refresh, { ...options, passive: true });
        window.addEventListener('resize', refresh, { ...options, passive: true });
        this.measurementObserver = new MutationObserver(refresh);
        this.measurementObserver.observe(this, { attributes: true, attributeFilter: ['data-sticky'] });
        this.buttonObserver = new MutationObserver(refresh);
        this.buttonObserver.observe(this.buttonContainer, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'hidden'] });
        if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
            if (!error && this.isConnected) refresh();
          });
        }
        refresh();
      }

      measurementPlacement() {
        return this.hasAttribute('data-sticky') ? 'main_sticky' : 'main_inline';
      }

      measurementAllowed() {
        return !window.Shopify?.designMode && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
      }

      visibleButton() {
        if (document.visibilityState !== 'visible' || this.buttonContainer.hidden || document.querySelector('dialog[open]')) return false;
        const button = this.querySelector(this.buttonSelector);
        if (!button || button.matches(':disabled, [disabled], [aria-disabled="true"]')) return false;
        const style = getComputedStyle(button);
        if (style.visibility !== 'visible' || style.display === 'none' || Number(style.opacity) === 0) return false;
        const box = button.getBoundingClientRect();
        if (!box.width || !box.height) return false;
        const visibleWidth = Math.max(0, Math.min(box.right, innerWidth) - Math.max(box.left, 0));
        const visibleHeight = Math.max(0, Math.min(box.bottom, innerHeight) - Math.max(box.top, 0));
        if (visibleWidth * visibleHeight < box.width * box.height * 0.5) return false;
        const hit = document.elementFromPoint(Math.max(0, Math.min(innerWidth - 1, box.left + box.width / 2)), Math.max(0, Math.min(innerHeight - 1, box.top + box.height / 2)));
        return !!hit && this.buttonContainer.contains(hit);
      }

      refreshMeasurement() {
        const placement = this.measurementPlacement();
        if (!this.measurementAllowed() || !this.visibleButton() || this.viewedPlacements.has(placement)) {
          clearTimeout(this.viewTimer);
          this.viewTimer = null;
          return;
        }
        if (this.viewTimer && this.pendingPlacement === placement) return;
        clearTimeout(this.viewTimer);
        this.pendingPlacement = placement;
        this.viewTimer = setTimeout(() => {
          this.viewTimer = null;
          if (this.isConnected && this.measurementPlacement() === placement && this.visibleButton() && this.sendMeasurement('buy_now_viewed', placement)) this.viewedPlacements.add(placement);
        }, 1000);
      }

      sendMeasurement(name, placement) {
        try {
          if (!this.measurementAllowed()) return false;
          if (typeof window.gtag !== 'function' && !window.dataLayer?.push) return false;
          const params = {
            send_to: this.dataset.measurementId,
            transport_type: 'beacon',
            offer_id: 'floral200',
            offer_role: 'base',
            offer_version: '20261026-v1',
            placement,
            action: 'buy_now',
            base_product_id: this.dataset.productId,
            is_internal_test: this.internalTest ? 1 : 0
          };
          if (typeof window.gtag === 'function') window.gtag('event', name, params);
          else (function () { window.dataLayer.push(arguments); })('event', name, params);
          return true;
        } catch {
          return false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
